const FilterIcon = () => (
    <svg width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.5 8.5V13L4.5 14.5V8.5L0 1.75V0.25H12V1.75L7.5 8.5ZM1.80277 1.75L6 8.0458L10.1972 1.75H1.80277Z" fill="#F2F2F2"/>
</svg> 

  );
  
  export default FilterIcon;
  